import React from 'react';
import VideoTranscript from '../VideoTranscript/index';
import './index.less';
import './index.en.less';

export interface ITopicIntroContentProps {
  title: string;
  icon: string;
  description: string;
  landingVideo?: { src: string };
  transcripts?: {
    language: string;
    transcripts: { time: string; text: string }[];
  }[];
  videoId?: string;
}

const TopicIntroContent: React.FunctionComponent<ITopicIntroContentProps> = ({
  title,
  icon,
  description,
  landingVideo,
  transcripts,
  videoId = 'topicIntroVideo',
}) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);

  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = videoRef.current;
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        elem.removeEventListener('play', onPlay);
      }
    };
    const elem = videoRef.current;
    elem?.removeEventListener('play', onPlay);
    elem?.addEventListener('play', onPlay, { passive: true });
    return () => elem?.removeEventListener('play', onPlay);
  }, []);

  return (
    <div className="topic-intro">
      <div className="topic-intro__header">
        <div className="topic-intro__icon-wrap">
          <img className="topic-intro__icon" src={icon} alt="" />
        </div>
        <h2 className="topic-intro__title">{title}</h2>
      </div>
      <div className="topic-intro__description">{description}</div>
      <div className="topic-intro__media">
        <div className="topic-intro__video">
          <video
            ref={videoRef}
            id={videoId}
            className="topic-intro__video-player"
            width="100%"
            controls
            playsInline
            autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
          >
            <source src={landingVideo?.src} type="video/mp4" />
            Your browser does not support HTML video.
          </video>
        </div>
        <VideoTranscript transcripts={transcripts ?? []} />
      </div>
    </div>
  );
};

export default TopicIntroContent;
